// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3tPai","alertIcon":"ConfirmModal_alertIcon__2dXk5"};